import { z } from 'zod';

export type Token = z.infer<typeof TokenSchema>;

export type TokenExpiration = z.infer<typeof TokenExpirationSchema>;

export const TokenSchema = z.string().nullable().transform((value) => value ?? '');

export const TokenExpirationSchema = z.object({
  remainingAttempts: z.number().nullable().transform((value) => value ?? Number.POSITIVE_INFINITY),
  blockedUntil: z.string().nullable().transform((value) => value ?? new Date().toISOString()),
});

export const TokenInfoSchema = z.object({
  validUntil: z.string().nullable().transform((value) => value ?? new Date().toISOString()),
  used: z.boolean(),
  resend: TokenExpirationSchema,
});
